import type { LngLat } from './geo'

/** Decode a Google-encoded polyline (Valhalla uses precision 6). */
export function decodePolyline(encoded: string, precision = 6): LngLat[] {
  const factor = 10 ** precision
  const coords: LngLat[] = []
  let lat = 0
  let lng = 0
  let i = 0
  while (i < encoded.length) {
    for (const which of [0, 1] as const) {
      let shift = 0
      let result = 0
      let byte: number
      do {
        byte = encoded.charCodeAt(i++) - 63
        result |= (byte & 0x1f) << shift
        shift += 5
      } while (byte >= 0x20)
      const delta = result & 1 ? ~(result >> 1) : result >> 1
      if (which === 0) lat += delta
      else lng += delta
    }
    coords.push([lng / factor, lat / factor])
  }
  return coords
}
